import React from "react";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import TableForm from "../../../forms/TableForm.jsx";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import { faPencilAlt, faTrash } from "@fortawesome/fontawesome-free-solid";

class Tables extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingTables: true,
      tableModal: false,
      targetTable: null,
      tables: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchTables();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.tableModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("TableForm");
                this.setState({ tableModal: true, targetTable: null });
              }}
            >
              Adicionar Mesa
            </Button>
          </Col>
        </Row>
        {this._renderTablesTable(this.state.tables)}
      </div>
    );
  }

  _fetchTables = () => {
    const { companyID } = this.props;
    this.setState({ fetchingTables: true });
    db.collection("companies")
      .doc(companyID)
      .collection("tables")
      .onSnapshot((tableSnapshot) => {
        if (!tableSnapshot.empty) {
          const tables = [];
          tableSnapshot.forEach((table) =>
            tables.push({ ...table.data(), id: table.id })
          );
          this.setState({ fetchingTables: false, tables });
        } else {
          this.setState({ fetchingTables: false });
        }
      });
  };

  _setTable = (values) => {
    this.setState({ tableModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("tables")
      .add({ name: values.name, products: values.products })
      .then(() => {
        this.hideAlert();
        this.notify("Mesa adicionada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar mesa", "error");
      });
  };

  _updateTable = (tableID) => (values) => {
    this.setState({ tableModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("tables")
      .doc(tableID)
      .update({ name: values.name, products: values.products })
      .then(() => {
        this.hideAlert();
        this.notify("Mesa atualizada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao atualizar mesa", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("table", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo, aguarde", false);
          db.collection("companies")
            .doc(companyID)
            .collection("tables")
            .doc(id)
            .delete()
            .then(() => {
              this.hideAlert();
              this.notify("Mesa removida", "success");
            })
            .catch((e) => {
              this.hideAlert();
              this.notify("Erro ao remover mesa", "error");
            });
        } else {
          this.hideAlert();
          this.notify(
            "Esta mesa possui ligações com os dados da empresa e não pode ser removida.",
            "warning"
          );
        }
      });
  };

  tableModal = () => {
    const { targetTable } = this.state;
    return (
      <Modal
        title={targetTable ? "Atualizar mesa" : "Adicionar mesa"}
        isOpen={this.state.tableModal}
        content={
          <TableForm
            companyID={this.props.companyID}
            initialValues={targetTable}
            onSubmit={(values) => {
              targetTable
                ? this._updateTable(targetTable.id)(values)
                : this._setTable(values);
            }}
            handleCancel={() =>
              this.setState({ tableModal: false, targetTable: null })
            }
          />
        }
      />
    );
  };

  _renderTablesTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Nome", accessor: "name" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetTable: value, tableModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={orderBy(toArray(data), ["name", "asc"])}
      onFetchData={this._fetchTables}
      loading={this.state.fetchingTables}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhuma mesa encontrada"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        />
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Tables);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Tables.jsx